import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Http } from '@angular/http';

import config from '../../config/config';
/**
 * Generated class for the AuditoriaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-auditoria',
  templateUrl: 'auditoria.html',
})
export class AuditoriaPage {
itens:any;
  constructor(
    public navCtrl: NavController,
    public loadingCtrl: LoadingController,    
    private _http : Http,
    public navParams: NavParams) {
  }

  ionViewDidLoad() {
  }
  buscar(data){
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    let env;
    if (data.month < 10) {
      env = data.year+"-0"+data.month;
    }else{
      env = data.year+"-"+data.month;
    }
    
    
    this._http
    .get(config.urlAPI + "auditoria/data/"+env, {})
    .map(res => res.json())
    .toPromise()
    .then(res => {
      loading.dismiss();
      this.itens = res;
      console.log(res);

    })
    .catch(error => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/auditoria/auditoria.ts